import type { GlobalNetworkState } from "@woven/contracts";
import type { StatusTone } from "../components/ui/StatusIndicator";

const STATE_TONE: Record<GlobalNetworkState, StatusTone> = {
  provisioning: "info",
  healthy: "ok",
  degraded: "warn",
  offline: "danger",
};

/** Maps the global network's aggregate state to its display tone. */
export function globalNetworkStateTone(state: GlobalNetworkState): StatusTone {
  return STATE_TONE[state];
}
